__turbopack_context__.v({
  "carousel": "_9FzZvW_carousel",
  "dotGroup": "_9FzZvW_dotGroup",
  "slide": "_9FzZvW_slide",
  "tray": "_9FzZvW_tray",
});
